<template>
  <v-container class="px-0 pt-0 pb-0" fluid>
    <v-row>
      <v-col cols="12" class="d-flex pt-0 pb-0">
        <v-textarea
          :rules="rules.email"
          hide-details="auto"
          name="input-7-1"
          v-model="company.email"
          label="Email"
          rows="2"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0 d-flex">
        <v-text-field
          name="name"
          type="text"
          v-model="company.name"
          label="Nombre/Empresa"
          :rules="rules.name"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex pt-0 pb-0">
        <v-text-field
          :rules="rules.nif"
          hide-details="auto"
          v-model="company.nif"
          label="NIF"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex pt-0 pb-0">
        <v-text-field
          :rules="rules.postal_code"
          hide-details="auto"
          v-model="company.postal_code"
          label="Código Postal"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex pt-0 pb-0">
        <v-text-field
          :rules="rules.city"
          hide-details="auto"
          v-model="company.city"
          label="Ciudad"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex pt-0 pb-0">
        <v-textarea
          :rules="rules.address"
          hide-details="auto"
          name="input-7-1"
          v-model="company.address"
          label="Dirección"
          rows="2"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Factura",
  data() {
    return {
      invoiceRequest: false,
      company: {
        name: "",
        address: "",
        nif: "",
        email: "",
        postal_code: null,
        city: ""
      },
      rules: {
        name: [v => !!v || "Nombre es requerido"],
        address: [v => !!v || "Dirección es requerido"],
        nif: [v => !!v || "NIF es requerido"],
        email: [v => !!v || "Email es requerido"],
        postal_code: [v => !!v || "Código Postal es requerido"],
        city: [v => !!v || "Ciudad es requerido"]

        // value => !!value || 'Required.',
        // value => (value && value.length >= 3) || 'Min 3 characters',
      }
    };
  }
};
</script>

<style scoped lang="scss"></style>
